// OfflinePopup.jsx

import { useSelector } from "react-redux";
// import noInternet from "../../public/noInternet.png"

export default function OfflinePopup() {
  const isOnline = useSelector((state) => state.network.isOnline);

  if (isOnline) return null;

  return (
    <div className="offline-overlay">
      <div className="offline-box">
        <div className="justify-self-center">
            <img src="/noInternet.png" alt="noInternet" className="h-[80px]"/>
        </div>
        <h3>No Internet Connection</h3>
        <p>Please check your internet connection.</p>

        <div className="spinner-border text-primary" />

        <p className="mt-3">
          Waiting for connection...
        </p>
      </div>
    </div>
  );
}